import React from 'react'
import { Route, Redirect, } from 'react-router-dom';
import { isAuthenticated } from '../../utils/Session';

const PrivateRoute = ({ component: Component, ...rest }) => {
    return <Route {...rest} render={(props) => {
        return isAuthenticated()
            ? <Component {...props} title={rest.title} />
            : <Redirect to={{
                pathname: '/login',
                state: { from: props.location }
            }} />
    }} />
};

export default PrivateRoute